import {
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY,
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
} from './actionTypes';

const initialState = {
  deletePlcSafetyZoneDependencyError: null,
  messagePlcSafetyZoneDependency: null,
  loadingDeletePlcSafetyZoneDependency: false,
};

const deleteZoneDependency = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PLC_SAFETY_ZONE_DEPENDENCY:
      state = { ...state, loadingDeletePlcSafetyZoneDependency: true, deletePlcSafetyZoneDependencyError: null };
      break;
    case DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL:
      state = {
        ...state,
        loadingDeletePlcSafetyZoneDependency: false,
        messagePlcSafetyZoneDependency: action.payload,
        deletePlcSafetyZoneDependencyError: null,
      };
      break;
    case DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED:
      state = {
        ...state,
        messagePlcSafetyZoneDependency: null,
        loadingDeletePlcSafetyZoneDependency: false,
        deletePlcSafetyZoneDependencyError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default deleteZoneDependency;
